import ko from 'knockout';

export default class InlineEditViewModel {
  constructor({
    error = '',
    isValid = true,
  }) {
    this.error = ko.observable(error);

    this.isValid = ko.observable(isValid);
  }
}
